export type CalculatorLayout = "classic" | "v1" | "v2" | "v3";

/** Unknown values keep the established embed unchanged. */
export function parseLayout(value: unknown): CalculatorLayout {
  return value === "v1" || value === "v2" || value === "v3" ? value : "classic";
}

export function layoutFromScriptUrl(url: string): CalculatorLayout {
  return parseLayout(new URL(url).searchParams.get("layout"));
}
